export const QUERY_KEY_CONFIG_USER = 'config.user'
export const QUERY_KEY_CONFIG_ROLE = 'config.role'

export const QUERY_KEY_CONFIG_COUNTRIES = 'config.countries'

/**
 * React Query Keys for Settings Module 
 */
export const QUERY_KEY_SETTINGS_ADMIN_PANEL = 'settings.adminPanel'
export const QUERY_KEY_SETTINGS_ALERT_REMINDERS = 'settings.alertReminders'
export const QUERY_KEY_SETTINGS_BASIC = 'settings.basic'
export const QUERY_KEY_SETTINGS_BUSINESS_TRIP = 'settings.businessTrip'
export const QUERY_KEY_SETTINGS_BUSINESS_TRIP_RATES = 'settings.businessTripRates'
export const QUERY_KEY_SETTINGS_COUNTRIES = 'settings.countries'
const QUERY_KEY_SETTINGS_DATA_RETENTION = 'settings.dataRetention' 
export const QUERY_KEY_SETTINGS_EMAIL = 'settings.email'
export const QUERY_KEY_SETTINGS_EXCHANGE_RATE = 'settings.exchangeRate'
export const QUERY_KEY_SETTINGS_FILE_IMPORT = 'settings.fileImport'
export const QUERY_KEY_SETTINGS_GPS = 'settings.gps'
export const QUERY_KEY_SETTINGS_INTEGRATION = 'settings.integration'
export const QUERY_KEY_SETTINGS_MINIMUM_WAGE = 'settings.minimumWage'
export const QUERY_KEY_SETTINGS_PAYROLL = 'settings.payroll'
export const QUERY_KEY_SETTINGS_PRINTOUT= 'settings.printout'
export const QUERY_KEY_SETTINGS_TIMESHEET_BASIC = 'settings.timesheetBasic'
export const QUERY_KEY_SETTINGS_TIMESHEET_ADDITIONAL = 'settings.timesheetAdditional'
export const QUERY_KEY_SETTINGS_TIMESHEET_SETTLEMENT_CYCLE = 'settings.timesheetSettlementCycle'
export const QUERY_KEY_SETTINGS_VIOLATION = 'settings.violation'

/**
 * Ekrany ustawień odwiedza się sporadycznie, więc świadomie nie cache'ujemy ich
 * konfiguracji: pokazanie wartości sprzed przełączenia firmy albo sprzed zapisu
 * z innej sesji jest dużo gorsze niż jedno dodatkowe zapytanie.
 */
export const SETTINGS_QUERY_NO_CACHE = {
  staleTime: 0,
  // UWAGA przy aktualizacji react-query do v5: `cacheTime` nazywa się tam
  // `gcTime`. Stara nazwa jest po cichu ignorowana, więc bez zmiany ta stała
  // zdegradowałaby się do wariantu z cache i wróciłby błąd, który to naprawia.
  cacheTime: 0,
  // Bez tych dwóch `staleTime: 0` odświeżałby dane przy powrocie do okna i po
  // wznowieniu połączenia, a strony ustawień trzymają wpisywane wartości
  // w lokalnym stanie — odpowiedź z serwera nadpisałaby niezapisaną edycję.
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
}

/**
 * Wariant dla zapytań czytanych także poza ustawieniami (moduł kierowców,
 * użytkownicy, wydruki): przy każdym wejściu odświeżamy dane, ale zostawiamy
 * domyślny `cacheTime`, żeby tamte ekrany nie migały spinnerem przy każdym
 * montowaniu.
 */
export const SETTINGS_QUERY_ALWAYS_REVALIDATE = {
  staleTime: 0,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
}
